export const openHomeSearchEventName = "smartguide:open-home-search";
export const returnToHomeMapEventName = "smartguide:return-to-home-map";
